module.exports = __webpack_public_path__ + "static/media/focus-question.ea83e400.md";